import { memo, useRef, useCallback } from 'react';
import { Grid } from 'ht-styleguide';
import { prevented } from '@utils/event';
import cn from 'classnames';
import { Children } from 'types/base.types';
import ReviewBanner from './ReviewBanner';
import styles from '../plansPage.module.scss';

type HeaderBlockProps = {
  title: string;
  subTitle: string;
  children: Children;
};
const HeaderBlock = ({ title, subTitle, children }: HeaderBlockProps) => {
  const linkStyles = cn('white', styles.link);
  const pricing = useRef(null);

  const onLearnMoreClick = useCallback(() => {
    const element = document.getElementById('infoBlock');
    // Lazy loaded component won't be on the DOM unless it is scrolled to, so element would be null
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({
        top: 1720, // Approx. location of the component
        behavior: 'smooth',
      });
    }
  }, []);

  return (
    <section className={styles.headerContainer}>
      <Grid.Fluid>
        <Grid.Row>
          <Grid.Column sm={4} md={6} mdOffset={1} lg={6} lgOffset={3} classes={styles.column}>
            <h1 className="h2 white paddingTop-large2 paddingBottom-small1">{title}</h1>
            <p data-testid="headerBlock-subTitle" className="p0 white paddingBottom-medium1">
              {subTitle}{' '}
              <a href="#" onClick={prevented(onLearnMoreClick)} className={linkStyles}>
                Learn More
              </a>
            </p>
            <ReviewBanner />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <div ref={pricing}>{children}</div>
          </Grid.Column>
        </Grid.Row>
      </Grid.Fluid>
    </section>
  );
};

export default memo(HeaderBlock);

/*
Usage:

import HeaderBlock from 'src/components/Sections/PlanHeaderBlock';
<HeaderBlock>
  <AnyComponent /> This will go inside the Header container
<HeaderBlock>

Props:
  title: customizable title,
  subTitle: customizable subtitle,
  children: Any child component within the Header container,
*/
